<template>
  <div
    class="app-progress-bar"
    :style="`width: ${width};`"
  >
    <div
      class="app-progress-bar__process"
      :style="`width: ${percent}%;`"
    />
  </div>
</template>

<script>
export default {
  name: 'AppProgressBar',
  props: {
    percent: {
      type: Number,
      default: 0,
    },
    width: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="scss" scoped>
  .app-progress-bar {
    height: 10px;
    background: #D7D9E5;
    border-radius: 10px;
    &__process {
      border-radius: 20px;
      height: 10px;
      background: #FF7522;
    }
  }

</style>
